
  const storageKey = (queue) => `mailroom:queue-filter:v2:${queue}`;

  window.addEventListener("phx:mailroom:queue-filter:updated", ({ detail }) => {
    sessionStorage.setItem(storageKey(detail.queue), JSON.stringify(detail));
  });

  export default {
    mounted() {
      const { queue, odsCode } = this.el.dataset;
      const stored = JSON.parse(sessionStorage.getItem(storageKey(queue)));
      if (stored?.odsCode === odsCode) this.pushEvent("mailroom:queue-filter:submitted", stored);
    },
  };
